/**
 * The Mood Tracking section's own vocabulary, mapped onto the panel-wide design
 * tokens in component/common/designSystem/theme.js — the same split shuruTheme.js
 * and vidsTheme.js use: only domain meaning lives here, palettes belong to the
 * design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * The three emotion bands, in the taxonomy's own order (green → amber → red).
 * The app calls them by colour and grids the emotion picker in exactly this
 * order, so the dashboard keeps the traffic-light reading rather than inventing
 * a brand ramp — this is a wellbeing signal, not a volume.
 */
export const BAND_RAMP = [CHART_COLORS.green, CHART_COLORS.amber, CHART_COLORS.red];

/** Band key → chart colour, for series that carry the key rather than a label. */
export const BAND_COLOR = {
  green: CHART_COLORS.green,
  amber: CHART_COLORS.amber,
  red: CHART_COLORS.red
};

/**
 * How often somebody checks in, 1 → 11+. Consistency is the thing that makes
 * mood tracking useful, so this is a plain sparse → regular ramp.
 */
export const FREQUENCY_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

/**
 * Morning → Afternoon → Evening → Night. Four windows of one day, so they run
 * light to dark rather than good to bad.
 */
export const DAY_PART_RAMP = [
  CHART_COLORS.amber,
  CHART_COLORS.orange,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];
